import SlideShowGallery_SlideShowPolaroidComponent from '../components/NativeGalleries/SlideShowGallery/viewer/skinComps/SlideShowPolaroid/SlideShowPolaroid.skin';
import SlideShowGallery_SlideShowPolaroidController from '../components/NativeGalleries/SlideShowGallery/viewer/SlideShowGallery.controller';


const SlideShowGallery_SlideShowPolaroid = {
  component: SlideShowGallery_SlideShowPolaroidComponent,
  controller: SlideShowGallery_SlideShowPolaroidController
};


export const components = {
  ['SlideShowGallery_SlideShowPolaroid']: SlideShowGallery_SlideShowPolaroid
};

